import { render } from "./ReviewReminder.vue?vue&type=template&id=9276bf24"
import script from "./ReviewReminder.vue?vue&type=script&lang=js"
export * from "./ReviewReminder.vue?vue&type=script&lang=js"

import "./ReviewReminder.vue?vue&type=style&index=0&id=9276bf24&lang=css"

import exportComponent from "C:\\Users\\User\\Desktop\\doc\\MedRemind Project\\medremind-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__